<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="primary">Cancel</button>
</mat-dialog-actions>
@if (data.mediaPath && isImage(data.mediaPath)) {
  <img [src]="data.mediaPath" />
}

@if (data.mediaPath && isVideo(data.mediaPath)) {
  <video controls>
    <source [src]="data.mediaPath" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
}
